import { FC } from 'react';

import { Campaign } from '../../../../types/Campaign';
import CampaignPageTabPanels from './Tabs/CampaignPageTabPanels';

interface CampaignPageContentProps {
    campaign: Campaign;
}

const CampaignPageContent: FC<CampaignPageContentProps> = () => {
    return (
        <>
            <CampaignPageTabPanels />
        </>
    );
};

export type { CampaignPageContentProps };
export default CampaignPageContent;
